import { Box, Dialog, DialogContent, DialogTitle, FormLabel, Grid } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { IModalProps } from 'src/models/interfaces/IModalProps'
import { StyledInput } from './styles/loginStyle'
import { useForm } from 'react-hook-form'
import ButtonUiKit from 'src/components/UI/button'
import ForgotPassword from '../forgotPassword/forgotPassword'
import ClientCaptcha from 'react-client-captcha'
import { IObject } from 'src/models/interfaces'
import { toast } from 'react-toastify'
import { ILoginParams, ILoginResData } from 'src/services/Account/interfaces'
import { AccountServices } from 'src/services/Account'
import { USER_TYPES_INDEX, localStoragesName } from 'src/models/enum'

import { useAppDispatch, useAppSelector } from 'src/hook'
import { login, setUserInfo, setUserType } from 'src/store/user'
import TextFieldUiKit from 'src/components/UI/TextField'
import SelectUiKit from 'src/components/UI/select'
import { error } from 'console'
import { ISelectItems } from 'src/components/UI/select/interfaces'
import { showLoginHandler } from 'src/store/common'
import { staticInsuranceList } from 'src/constants/Insurance/staticInsuranceList'
import { PatientServices } from 'src/services/Patient'
import { smsService } from 'src/services/Sms'
import VerifyConfirmeCode from './components/verifyConfirmeCode'
import logo from '../../assets/images/common/logo-dark.png'
import logoLight from '../../assets/images/common/logo-light.png'
import homePage from '../../assets/images/login-slider/homePage.png'
import reserveTimePage from '../../assets/images/login-slider/reserveTimePage.png'
import consulationPage from '../../assets/images/login-slider/consultationPage.png'
import Carousel from 'react-material-ui-carousel'
import CarouselItem from './components/carouselItem'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { setDataDoctor } from 'src/store/doctor'

const sliderItems = [
  {
    imageSrc: homePage,
    caption: 'جستجو پیشرفته',
  },

  {
    imageSrc: reserveTimePage,
    caption: 'نوبت دهی اینترنتی',
  },

  {
    imageSrc: consulationPage,
    caption: 'مشاوره آنلاین',
  },
]

const genderItems: ISelectItems[] = [
  { label: 'مرد', value: 1 },
  { label: 'زن', value: 2 },
]

const insuranceItems: ISelectItems[] = staticInsuranceList.map(x => ({ label: x.title, value: x.id }))

const Login = () => {
  //#region Dependencies
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm()
  const { loginRequest } = AccountServices()
  const { getConfirmationCodeAnonymous } = smsService()
  const { AddPatientAnonymousAsync } = PatientServices()
  const dispatch = useAppDispatch()
  const { doctorId, clinicId, officeId } = useAppSelector(s => s.doctorData)

  //#endregion

  //#region States
  const [open, setOpen] = useState(true)
  const [openVerify, setOpenVerify] = useState(false)
  const [values, setValues] = useState<IObject>()
  const [isLogin, setisLogin] = useState(true)
  const [loading, setLoading] = useState<boolean>()
  const [captchaCode, setCaptchaCode] = useState<string>()
  const [captchaKey, setCapcthaKey] = useState<number>(1)
  const [showCaptcha, setShowCaptcha] = useState<boolean>(false)
  const [forgotPasswordModlaState, setForgotPasswordModalState] = useState<boolean>(false)
  //#endregion

  //#region Functions

  const handleClose = () => {
    dispatch(showLoginHandler(false))
  }
  const savePatientDataHandler = (data?: ILoginResData) => {
    data?.userInfo && dispatch(setUserInfo(data?.userInfo))
    dispatch(setUserType(USER_TYPES_INDEX.patient))
    sessionStorage.setItem(localStoragesName.userType, JSON.stringify(USER_TYPES_INDEX.patient))
    handleClose()
    // navigate('/')
  }

  const resetCaptcha = () => {
    setValue('captcha', '')
    setCapcthaKey(Math.floor(Math.random() * 1000) + 1)
  }

  const captchaIsValid = (): boolean => {
    console.log(getValues('captcha').toLowerCase().trim())
    console.log(captchaCode!.toLowerCase())
    if (getValues('captcha').toLowerCase().trim() !== captchaCode!.toLowerCase()) return false
    return true
  }

  const onSubmit = async (values: IObject) => {
    if (showCaptcha) {
      if (!captchaIsValid()) {
        toast.error('کد امنیتی صحیح نمی باشد')
        resetCaptcha()
        return
      }

      resetCaptcha()
    }

    setLoading(true)

    const bodyData: ILoginParams = {
      username: values.username,
      password: values.password,
    }

    try {
      const { data, statusCode } = await loginRequest(bodyData)

      localStorage.removeItem('showCapcha')

      const userTypes = data?.userInfo?.userTypes
      if (!userTypes || userTypes.length < 0) {
        toast.error('این نام کاربری معتبر نمی باشد')
        return
      }

      const isPatientType = !!userTypes.find(type => type.id === USER_TYPES_INDEX.patient)

      if (isPatientType) {
        dispatch(login({ token: data?.token! }))
        savePatientDataHandler(data)
        return
      } else {
        if (data.availableDoctors.length && (data.availableOffices.length || data.availableClinics.length)) {
          let office = null
          let clinic = null

          office = data.availableOffices[0] || null
          if (!office) clinic = data.availableClinics[0] || null

          dispatch(setDataDoctor({ doctorId: data.availableDoctors[0].id, officeId: office?.id || null, clinicId: clinic?.id || null }))
          setisLogin(false)
        }
      }
    } catch {
      localStorage.setItem('showCapcha', 'true')
      setShowCaptcha(true)
    } finally {
      setLoading(false)
    }
  }

  const registerPatient = async (values: IObject) => {
    await getConfirmationCodeAnonymous(values.mobile)

    setValues(values)
    setOpenVerify(true)
  }
  const addPatient = async (code: string) => {
    try {
      setLoading(true)

      if (!values || !doctorId) return

      await AddPatientAnonymousAsync({
        confirmationCode: code,
        patientInfo: {
          doctorId: doctorId!,
          clinicId: clinicId,
          officeId: officeId,
          patient: {
            insuranceId: values.insuranceId,
            smsPhone: values.mobile,
          },
          user: {
            firstName: values.firstName,
            lastName: values.lastName,
            mobile: values.mobile,
            phoneNumber: values.mobile,
            gender: values.gender,
            nationalCode: values.nationalCode,
            password: values.password,
            userName: values.userName,
            userType: USER_TYPES_INDEX.patient,
          },
        },
      })
      setShowCaptcha(false)

      await onSubmit({
        username: values.userName,
        password: values.password,
      })
    } finally {
      setLoading(false)
    }
  }

  const renderLogin = () => {
    return (
      <DialogContent className=" !m-0 !p-0  ">
        <Grid container spacing={2}>
          <Grid item xs={12} className="flex !flex-col items-center !px-1 !py-[50px]">
            <img src={logo} width={100} height={100} />
           
            <h6 className="mb-4 text-[0.9rem]">سامانه نوبت دهی و مشاوره آنلاین</h6>
            <form className="w-[80%]">
              <div className="flex justify-center items-center gap-1">
                {/* <FormLabel className="!text-[0.9rem] whitespace-nowrap" >نام کاربری</FormLabel> */}
                <StyledInput type="text" {...register('username', { required: true })} placeholder="نام کاربری" />
              </div>
              <div className="flex justify-center items-center gap-1">
                {/* <FormLabel className="!text-[0.9rem] whitespace-nowrap">کلمه عبور</FormLabel> */}
                <StyledInput type="password" {...register('password', { required: true })} placeholder="کلمه عبور" />
              </div>

              <Grid item container spacing={1} display={!showCaptcha ? 'none' : ''}>
                <Grid item xs={5} sm={5} padding={0} paddingTop={'1.2rem'}>
                  <ClientCaptcha key={captchaKey} retryIcon="/ReactIcons/retry.svg" captchaCode={(code: string) => setCaptchaCode(code)} />
                </Grid>

                <Grid item xs={7} sm={7} padding={0}>
                  <StyledInput type="text" {...register('captcha', { required: showCaptcha })} placeholder="کد امنیتی " />
                </Grid>
              </Grid>

              <ButtonUiKit
                loading={loading}
                classes={{ root: '!tracking-widest' }}
                variant="contained"
                fullWidth
                onClick={handleSubmit(onSubmit)}
              >
                ورود
              </ButtonUiKit>
            </form>

            <Grid item xs={12}>
              <button style={{ fontSize: 13, color: '#7f8c97', marginTop: '1rem' }} onClick={() => setForgotPasswordModalState(true)}>
                رمز عبور خود را فراموش کرده اید؟
              </button>

              {forgotPasswordModlaState && (
                <ForgotPassword open={forgotPasswordModlaState} onClose={() => setForgotPasswordModalState(false)} />
              )}
            </Grid>
            <Grid item xs={12}>
              {doctorId && (
                <button style={{ fontSize: 13, color: 'blue', marginTop: '1rem' }} onClick={() => setisLogin(false)}>
                  ثبت نام
                </button>
              )}
            </Grid>
          </Grid>
          {/* <Grid item xs={6} className="bg-blue-600 ">
                        <Box className="flex justify-center items-center p-4 pt-[30%]" >
                            <Carousel
                                className="!w-full !h-full"
                                fullHeightHover={true}

                                NextIcon={<ArrowBackIosNewIcon />}
                                PrevIcon={<ArrowForwardIosIcon />}

                            >
                                {
                                    sliderItems.map((x, i) => (
                                        <CarouselItem caption={x.caption} key={i}>
                                            <img src={x.imageSrc} className="rounded-xl" />
                                        </CarouselItem>
                                    ))
                                }
                            </Carousel>
                        </Box>

                    </Grid> */}
        </Grid>
      </DialogContent>
    )
  }

  const renderRegister = () => {
    return (
      <>
        <DialogTitle className="flex gap-2 bg-blue-600 text-white !text-[1rem] ">
          <img src={logoLight} width={30} height={30} style={{ objectFit: 'fill' }} />
          ثبت نام در سامانه پارسیز طب
        </DialogTitle>
        <DialogContent className="flex flex-col items-center">
          {values && (
            <VerifyConfirmeCode mobile={values.mobile} onSubmit={addPatient} open={openVerify} onClose={() => setOpenVerify(false)} />
          )}
          <form>
            <Grid container spacing={2} mt={2}>
              <Grid item xs={12} sm={6}>
                <TextFieldUiKit
                  label="نام کاربری"
                  name="userName"
                  register={register}
                  validation={{ required: true, validate: val => /^[\x00-\x7F]*$/.test(val) }}
                  error={!!errors.userName}
                  helperText={!!errors.userName ? 'نام کاربری دلخواه را به صورت لاتین وارد نمایید' : ''}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldUiKit
                  label="کلمه عبور"
                  name="password"
                  type="password"
                  register={register}
                  validation={{ required: true, minLength: 6, validate: val => /^[\x00-\x7F]*$/.test(val) }}
                  error={!!errors.password}
                  helperText={!!errors.password ? ' طول کلمه عبور باید حداقل شش حرف و به صورت لاتین وارد شود ' : ''}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldUiKit
                  label="نام"
                  name="firstName"
                  register={register}
                  validation={{ required: true, validate: val => /^[\u0600-\u06FF\s]+$/.test(val) }}
                  error={!!errors.firstName}
                  helperText={!!errors.firstName ? 'نام  خود را به صورت فارسی وارد نمایید' : ''}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldUiKit
                  label="نام خانوادگی"
                  name="lastName"
                  register={register}
                  validation={{ required: true, validate: val => /^[\u0600-\u06FF\s]+$/.test(val) }}
                  error={!!errors.lastName}
                  helperText={!!errors.lastName ? 'نام خانوادگی خود را به صورت فارسی وارد نمایید' : ''}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldUiKit
                  label="کدملی"
                  name="nationalCode"
                  register={register}
                  validation={{ required: true, validate: val => /^(\d{10}|\d{12})$/.test(val) }}
                  error={!!errors.nationalCode}
                  helperText={!!errors.nationalCode ? 'کد ملی باید ده یا دوازده رقمی باشد' : ''}
                  inputProps={{ maxLength: 12 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextFieldUiKit
                  label="شماره همراه"
                  name="mobile"
                  register={register}
                  validation={{ required: true, validate: val => /^(\+98?)?{?(0?9[0-9]{9,9}}?)$/.test(val) }}
                  error={!!errors.mobile}
                  helperText={!!errors.mobile ? 'شماره همراه خود را وارد کنید' : ''}
                  inputProps={{ maxLength: 11 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectUiKit
                  items={genderItems}
                  label="جنسیت"
                  name="gender"
                  register={register}
                  validation={{ required: true }}
                  inputProps={{ error: !!errors.gender }}
                  defaultValue={1}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <SelectUiKit
                  items={insuranceItems}
                  name="insuranceId"
                  label="بیمه"
                  register={register}
                  validation={{ required: true }}
                  inputProps={{ error: !!errors.insuranceId }}
                  defaultValue={1}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonUiKit loading={loading} className="btn-submit" variant="contained" fullWidth onClick={handleSubmit(registerPatient)}>
                  ثبت نام
                </ButtonUiKit>
              </Grid>
            </Grid>
          </form>
          <Grid>
            <button style={{ fontSize: 13, color: 'blue', marginTop: '1rem' }} onClick={() => setisLogin(true)}>
              ورود
            </button>
          </Grid>
        </DialogContent>
      </>
    )
  }

  //#endregion

  //#region Effects
  useEffect(() => {
    setShowCaptcha(!!localStorage.getItem('showCapcha'))
  }, [showCaptcha])
  //#endregion

  return (
    <Dialog open={open}  maxWidth={'sm'} fullWidth classes={{ paper: isLogin ? '!max-w-[400px]' : '' }}>
      {isLogin ? renderLogin() : renderRegister()}
    </Dialog>
  )
}
export default Login
